var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1200px",
        title: _vm.editData.id ? "修改产品库信息" : "新增产品库信息",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        "append-to-body": "",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "中文品名", prop: "nameCH" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "510px" },
                    model: {
                      value: _vm.form.nameCH,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "nameCH", $$v)
                      },
                      expression: "form.nameCH",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "英文品名", prop: "nameEN" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "510px" },
                    model: {
                      value: _vm.form.nameEN,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "nameEN", $$v)
                      },
                      expression: "form.nameEN",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用途", prop: "used" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    model: {
                      value: _vm.form.used,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "used", $$v)
                      },
                      expression: "form.used",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "材质", prop: "material" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    model: {
                      value: _vm.form.material,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "material", $$v)
                      },
                      expression: "form.material",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单价最小值", prop: "priceMin" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: 0.01,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.priceMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "priceMin", $$v)
                      },
                      expression: "form.priceMin",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "单价最大值", prop: "priceMax" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: _vm.form.priceMin,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.priceMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "priceMax", $$v)
                      },
                      expression: "form.priceMax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "重量最小值", prop: "weightMin" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: 0.01,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.weightMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "weightMin", $$v)
                      },
                      expression: "form.weightMin",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "重量最大值", prop: "weightMax" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: _vm.form.weightMin,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.weightMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "weightMax", $$v)
                      },
                      expression: "form.weightMax",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "箱重最小值", prop: "pkgWeightMin" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: 0.01,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.pkgWeightMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pkgWeightMin", $$v)
                      },
                      expression: "form.pkgWeightMin",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "箱重最大值", prop: "pkgWeightMax" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: _vm.form.pkgWeightMin,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.pkgWeightMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pkgWeightMax", $$v)
                      },
                      expression: "form.pkgWeightMax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "价重比最小值", prop: "priceWeightMin" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: 0.01,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.priceWeightMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "priceWeightMin", $$v)
                      },
                      expression: "form.priceWeightMin",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "价重比最大值", prop: "priceWeightMax" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      "controls-position": "right",
                      min: _vm.form.priceWeightMin,
                      precision: 2,
                      step: 1,
                    },
                    model: {
                      value: _vm.form.priceWeightMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "priceWeightMax", $$v)
                      },
                      expression: "form.priceWeightMax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "美国税号", prop: "hsCode" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "290px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.hsCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hsCode", $$v)
                      },
                      expression: "form.hsCode",
                    },
                  }),
                  _c("i", {
                    staticClass: "el-icon-search icon",
                    on: { click: _vm.search },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "批次号", prop: "batchNo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.batchNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "batchNo", $$v)
                      },
                      expression: "form.batchNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "基础税率", prop: "baseRate" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.baseRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "baseRate", $$v)
                      },
                      expression: "form.baseRate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "加征税率", prop: "addRate" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.addRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "addRate", $$v)
                      },
                      expression: "form.addRate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "芬太尼税率", prop: "addRate1" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.addRate1,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "addRate1", $$v)
                      },
                      expression: "form.addRate1",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "对等关税税率", prop: "addRate2" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.addRate2,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "addRate2", $$v)
                      },
                      expression: "form.addRate2",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "钢铁铝加征税率", prop: "addRate3" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.addRate3,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "addRate3", $$v)
                      },
                      expression: "form.addRate3",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v(" 确定" + _vm._s(_vm.editData.id ? "修改" : "新增") + " ")]
          ),
          _vm.editData.id || _vm.type
            ? _c(
                "div",
                {
                  staticClass: "ok flex_c_c",
                  staticStyle: { "margin-left": "16px" },
                  on: {
                    click: function ($event) {
                      return _vm.save("form")
                    },
                  },
                },
                [_vm._v(" 确定并确认 ")]
              )
            : _vm._e(),
        ]
      ),
      _c("TaxDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }